module.exports = __webpack_public_path__ + "img/expand.10ab15d5.svg";